import React from 'react';
import CryptoContent from '../components/CryptoContent';

const Crypto = () => {
  return (
    <>
    <CryptoContent />
    </>
  );
};

export default Crypto;
